import type { FormEvent } from "react";

export function focusFirstInvalidField(event: FormEvent<HTMLFormElement>) {
  const form = event.currentTarget;

  // Final Form renders validation errors after the submit event finishes.
  requestAnimationFrame(() => {
    if (!form.isConnected) return;

    const invalidFields = form.querySelectorAll<HTMLElement>(
      '[aria-invalid="true"], .Mui-error, input:invalid, textarea:invalid, select:invalid',
    );
    const controlSelector =
      'input:not([type="hidden"]):not([tabindex="-1"]):not([aria-hidden="true"]):not(:disabled), textarea:not(:disabled), select:not(:disabled), [role="combobox"][tabindex="0"], [role="spinbutton"][tabindex="0"], [role="button"][tabindex="0"]';

    for (const invalid of Array.from(invalidFields)) {
      const field =
        invalid.closest<HTMLElement>(".MuiFormControl-root") ?? invalid;
      const control = field.matches(controlSelector)
        ? field
        : Array.from(field.querySelectorAll<HTMLElement>(controlSelector)).find(
            (candidate) =>
              (candidate.closest(".MuiFormControl-root") ?? field) === field,
          );
      if (!control) continue;

      control.focus({ preventScroll: true });
      field.scrollIntoView({ block: "center" });
      return;
    }
  });
}
